module.exports = __webpack_public_path__ + "static/slide7-50f801c9d74b6352dfe5ddaf0124b1f2.jpg";